import { TEST_METHODS } from '@/constants/tests'

import CustomPageConfig from '@/config/methods/custom-page.js'
import SinglePageConfig from '@/config/methods/single-page.js'
import DefaultConfig from '@/config/methods/default.js'

export default {
  [TEST_METHODS.CUSTOM]: CustomPageConfig,
  [TEST_METHODS.PAGE]: SinglePageConfig,
  default: DefaultConfig
}
